var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selected_page == 'other_email')?_c('OtherEmail',{on:{"switchPage":_vm.switchPage}}):(_vm.selected_page == 'meritios_email')?_c('MeritiosEmail',{on:{"switchPage":_vm.switchPage}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }